<template>
  <div>
    <!-- 密码修改框 -->
    <ChangePasswordDialog v-if="visible('ChangePasswordDialog')" />

    <!-- 禁言编辑框 -->
    <EditChatBanDialog v-if="visible('EditChatBanDialog')" />

    <!-- 白名单编辑框 -->
    <EditWhiteListDialog v-if="visible('EditWhiteListDialog')" />

    <!-- 排行榜对话框 -->
    <LeaderboardDialog v-if="visible('LeaderboardDialog')" />

    <!-- 补单对话框 -->
    <CompensationOrderDialog v-if="visible('CompensationOrderDialog')" />

    <!-- 订单详情对话框 -->
    <OrdersInfoDialog v-if="visible('OrdersInfoDialog')" />

    <!-- 分区白名单编辑弹窗 -->
    <EditZoneWhiteDialog v-if="visible('EditZoneWhiteDialog')" />

    <!-- 打开查询累充最先抵达玩家对话框 -->
    <QueryTheFirstPlayerOfCostXYuanDialog
      v-if="visible('QueryTheFirstPlayerOfCostXYuanDialog')"
    />

    <!-- 强更新配置编辑弹窗 -->
    <EditForceUpdateConfigDialog
      v-if="visible('EditForceUpdateConfigDialog')"
    />

    <!-- 热更配置编辑框 -->
    <EditHotUpdateConfigDialog v-if="visible('EditHotUpdateConfigDialog')" />

    <!-- 定时邮件编辑框 -->
    <UpdateScheduledMailDialog v-if="visible('UpdateScheduledMailDialog')" />

    <!-- 新增禁言关键字弹窗 -->
    <AddChatBanKeywordsDialog v-if="visible('AddChatBanKeywordsDialog')" />

    <!-- 兑换码礼包编辑框 -->
    <EditRedeemCodeGiftDialog v-if="visible('EditRedeemCodeGiftDialog')" />
    <!-- 新增兑换码编辑框 -->
    <AddRedeemCodeDialog v-if="visible('AddRedeemCodeDialog')" />
    <!-- 兑换码礼包详情弹窗 -->
    <RedeemCodeGiftDetailsDialog
      v-if="visible('RedeemCodeGiftDetailsDialog')"
    />
    <!-- 渠道编辑框 -->
    <EditChannelConfigDialog v-if="visible('EditChannelConfigDialog')" />
    <!-- 合服编辑框 -->
    <MergeZonesDialog v-if="visible('MergeZonesDialog')" />
    <!-- 合服进度框 -->
    <MergeZonesProcessDialog v-if="visible('MergeZonesProcessDialog')" />
    <!--子分区框 -->
    <ChildZoneListPageDialog v-if="visible('ChildZoneListPageDialog')" />
    <!--分区编辑框 -->
    <EditZoneDialog v-if="visible('EditZoneDialog')" />
    <!--邮件附件编辑框 -->
    <EditMailPropsTemplateDialog
      v-if="visible('EditMailPropsTemplateDialog')"
    />

    <!-- 批注编辑框 -->
    <EditMicrofilmDialog v-if="visible('EditMicrofilmDialog')" />

    <!-- 子活动配置参数查看框 -->
    <ChildActivityConfigParameterDialog
      v-if="visible('ChildActivityConfigParameterDialog')"
    />
    <!-- 子活动配置编辑框 -->
    <EditChildActivityConfigDialog
      v-if="visible('EditChildActivityConfigDialog')"
    />
    <!-- 活动配置编辑框 -->
    <EditActivityConfigDialog v-if="visible('EditActivityConfigDialog')" />

    <!-- 子活动活动编辑框--英雄冲分礼包 -->
    <EditHeroUpgradeGiftDialog v-if="visible('EditHeroUpgradeGiftDialog')" />

    <!-- 子活动活动编辑框--英雄冲分礼包 -->
    <EditHeroUpgradeTaskDialog v-if="visible('EditHeroUpgradeTaskDialog')" />

    <!-- 子活动活动编辑框--英雄冲分排行榜 -->
    <EditHeroUpgradeLeaderboardDialog
      v-if="visible('EditHeroUpgradeLeaderboardDialog')"
    />
    <!-- 子活动活动编辑框--周年任务的每日任务 -->
    <EditDayTaskDialogOfAnniversaryMission
      v-if="visible('EditDayTaskDialogOfAnniversaryMission')"
    />
    <!-- 使用GM白名单编辑框-->
    <EditWhiteListEntryOfGmDialog
      v-if="visible('EditWhiteListEntryOfGmDialog')"
    />
  </div>
</template>

<script>
import ChangePasswordDialog from "@/components/dialogs/ChangePasswordDialog";
import EditMicrofilmDialog from "@/components/dialogs/EditMicrofilmDialog";
import EditChatBanDialog from "@/pages/chat/EditChatBanDialog";
import EditWhiteListDialog from "@/pages/white-list/EditWhiteListDialog";
import LeaderboardDialog from "@/pages/zone/LeaderboardDialog";
import CompensationOrderDialog from "@/pages/player/tab-pages/dialog/CompensationOrderDialog";
import OrdersInfoDialog from "@/pages/player/tab-pages/dialog/OrdersInfoDialog";
import EditZoneWhiteDialog from "@/pages/white-list/EditZoneWhiteDialog";
import QueryTheFirstPlayerOfCostXYuanDialog from "@/pages/zone/QueryTheFirstPlayerOfCostXYuanDialog";
import EditForceUpdateConfigDialog from "@/pages/version/tab-pages/EditForceUpdateConfigDialog";
import EditHotUpdateConfigDialog from "@/pages/version/tab-pages/EditHotUpdateConfigDialog";
import UpdateScheduledMailDialog from "@/pages/mail/UpdateScheduledMailDialog";
import AddChatBanKeywordsDialog from "@/pages/chat/AddChatBanKeywordsDialog";
import EditRedeemCodeGiftDialog from "@/pages/redeem-code/EditRedeemCodeGiftDialog";
import AddRedeemCodeDialog from "@/pages/redeem-code/AddRedeemCodeDialog";
import RedeemCodeGiftDetailsDialog from "@/pages/redeem-code/RedeemCodeGiftDetailsDialog";
import EditChannelConfigDialog from "@/pages/system-config/EditChannelConfigDialog";
import ChildActivityConfigParameterDialog from "@/pages/activity/ChildActivityConfigParameterDialog";
import EditChildActivityConfigDialog from "@/pages/activity/EditChildActivityConfigDialog";
import EditActivityConfigDialog from "@/pages/activity/EditActivityConfigDialog";
import MergeZonesDialog from "@/pages/system-config/MergeZonesDialog";
import MergeZonesProcessDialog from "@/pages/system-config/MergeZonesProcessDialog";
import ChildZoneListPageDialog from "@/pages/zone/ChildZoneListPageDialog";
import EditZoneDialog from "@/pages/zone/EditZoneDialog";
import EditMailPropsTemplateDialog from "@/pages/mail/tab-pages/dialog/EditMailPropsTemplateDialog";
import EditHeroUpgradeGiftDialog from "@/pages/activity/child_config_param_template/dialogs/EditHeroUpgradeGiftDialog";
import EditHeroUpgradeTaskDialog from "@/pages/activity/child_config_param_template/dialogs/EditHeroUpgradeTaskDialog";
import EditHeroUpgradeLeaderboardDialog from "@/pages/activity/child_config_param_template/dialogs/EditHeroUpgradeLeaderboardDialog";
import EditDayTaskDialogOfAnniversaryMission from "@/pages/activity/child_config_param_template/dialogs/EditDayTaskDialogOfAnniversaryMission";
import EditWhiteListEntryOfGmDialog from "@/pages/player/tab-pages/dialog/EditWhiteListEntryOfGmDialog";
export default {
  components: {
    ChangePasswordDialog,
    EditChatBanDialog,
    EditWhiteListDialog,
    LeaderboardDialog,
    CompensationOrderDialog,
    OrdersInfoDialog,
    EditZoneWhiteDialog,
    QueryTheFirstPlayerOfCostXYuanDialog,
    EditForceUpdateConfigDialog,
    EditHotUpdateConfigDialog,
    UpdateScheduledMailDialog,
    AddChatBanKeywordsDialog,
    EditRedeemCodeGiftDialog,
    AddRedeemCodeDialog,
    RedeemCodeGiftDetailsDialog,
    EditChannelConfigDialog,
    ChildActivityConfigParameterDialog,
    EditChildActivityConfigDialog,
    EditActivityConfigDialog,
    MergeZonesDialog,
    MergeZonesProcessDialog,
    ChildZoneListPageDialog,
    EditZoneDialog,
    EditMailPropsTemplateDialog,
    EditHeroUpgradeGiftDialog,
    EditMicrofilmDialog,
    EditHeroUpgradeTaskDialog,
    EditHeroUpgradeLeaderboardDialog,
    EditDayTaskDialogOfAnniversaryMission,
    EditWhiteListEntryOfGmDialog,
  },
  methods: {
    visible(name) {
      if (this.$dialogutil.visible(name) == undefined) {
        this.$dialogutil.registerModule(name);
      }
      return this.$dialogutil.visible(name);
    },
  },
};
</script>
